<template>
  <v-container fluid class="scroll-y fullscreen" pa-0>
    <v-card
        class="mx-auto"
        flat
        :loading="loading"
        loader-height="10"
        tile
    >
        <v-toolbar
        color="primary"
        dark
        flat
        >
            <v-spacer></v-spacer>
            <v-dialog
              v-model="dialog"
              max-width="500px"
              scrollable
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  tile
                  depressed
                  large
                >
                  <v-icon dark>mdi-plus</v-icon>
                  Add New
                </v-btn>
              </template>
              <v-card flat color="#004889">
                <v-card-title class="accent">
                  <span class="title text-uppercase white--text">{{ formTitle }}</span>
                  <v-spacer></v-spacer> 
                </v-card-title>

                <v-card-text class="pa-0">
                    <ValidationObserver ref="observer1">
                      <v-form ref="warrantyform">
                        <v-list flat color="#004889" class="py-0">
                          <v-list-item class="form-row">
                              <v-list-item-content class="label">
                                  <v-list-item-title class="font-weight-bold">Property</v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action>
                                <ValidationProvider v-slot="{ errors }" name="Property" rules="required">
                                  <v-select
                                      v-model="form.property_id"
                                      :items="properties"
                                      item-text="title"
                                      item-value="id"
                                      required
                                      :error-messages="errors"
                                      solo
                                      flat
                                      dark
                                      @change="getContacts"
                                  ></v-select>
                                </ValidationProvider>
                              </v-list-item-action>
                          </v-list-item>
                          <v-list-item class="form-row">
                              <v-list-item-content class="label">
                                  <v-list-item-title class="font-weight-bold">Task</v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action>
                                  <ValidationProvider v-slot="{ errors }" name="Task" rules="required">
                                    <v-text-field
                                      v-model="form.task"
                                      :error-messages="errors"
                                      required
                                      solo
                                      flat
                                      dark
                                    ></v-text-field>
                                  </ValidationProvider>
                              </v-list-item-action>
                          </v-list-item>
                          <v-list-item class="form-row">
                              <v-list-item-content class="label">
                                  <v-list-item-title class="font-weight-bold">Description</v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action>
                                  <ValidationProvider v-slot="{ errors }" name="Description" rules="required">
                                    <v-textarea
                                      v-model="form.description"
                                      :error-messages="errors"
                                      required
                                      solo
                                      flat
                                      dark
                                    ></v-textarea>
                                  </ValidationProvider>
                              </v-list-item-action>
                          </v-list-item>
                          <v-list-item class="form-row">
                              <v-list-item-content class="label">
                                  <v-list-item-title class="font-weight-bold">Contact</v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action>
                                  <ValidationProvider v-slot="{ errors }" name="Contact" rules="required">
                                    <v-select
                                        v-model="form.contact"
                                        :items="contacts"
                                        item-text="name"
                                        item-value="id"
                                        required
                                        :error-messages="errors"
                                        solo
                                        flat
                                        dark
                                        multiple
                                    ></v-select>
                                  </ValidationProvider>
                              </v-list-item-action>
                          </v-list-item>
                          <v-list-item class="form-row">
                              <v-list-item-content class="label">
                                  <v-list-item-title class="font-weight-bold">Status</v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action>
                                <ValidationProvider v-slot="{ errors }" name="Status" rules="required">
                                  <v-select
                                      v-model="form.status"
                                      :items="statuses"
                                      item-text="label"
                                      item-value="value"
                                      required
                                      :error-messages="errors"
                                      solo
                                      flat
                                      dark
                                  ></v-select>
                                </ValidationProvider>
                              </v-list-item-action>
                          </v-list-item>
                          <v-list-item class="form-row">
                              <v-list-item-content class="label">
                                  <v-list-item-title class="font-weight-bold">Date</v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action>
                                <v-menu
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="computedDateFormatted"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        solo
                                        flat
                                        dark
                                        clearable
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker
                                    v-model="form.date"
                                    @input="menu = false"
                                    ></v-date-picker>
                                </v-menu>
                              </v-list-item-action>
                          </v-list-item>
                          <v-list-item class="form-row">
                              <v-list-item-content class="label">
                                  <v-list-item-title class="font-weight-bold">Assignee</v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action>
                                <ValidationProvider v-slot="{ errors }" name="Assignee" rules="required">
                                  <v-select
                                      v-model="form.assignee"
                                      :items="users"
                                      item-text="name"
                                      item-value="id"
                                      :error-messages="errors"
                                      clearable
                                      solo
                                      flat
                                      dark
                                  ></v-select>
                                </ValidationProvider>
                              </v-list-item-action>
                          </v-list-item>
                        </v-list>
                      </v-form>
                    </ValidationObserver>
                  </v-card-text>
                  <v-card-actions class="accent">
                    <v-btn
                      large min-width="49%" color="white" text
                      @click="close"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      large min-width="49%" color="primary" tile
                      @click="save"
                      :loading="loading"
                    >
                      Save
                    </v-btn>
                  </v-card-actions>
              </v-card>
            </v-dialog>
        </v-toolbar>
    </v-card>
    <v-row class="fill-height">
        <v-col class="pt-0 pb-0">
            <v-sheet height="64">
                <v-toolbar flat color="white">
                  <v-btn outlined class="mr-4" @click="setToday" v-if="view == 'calendar'">
                      Today
                  </v-btn>
                  <v-btn fab text small @click="prev" v-if="view == 'calendar'">
                      <v-icon small>mdi-chevron-left</v-icon>
                  </v-btn>
                  <v-btn fab text small @click="next" v-if="view == 'calendar'">
                      <v-icon small>mdi-chevron-right</v-icon>
                  </v-btn>
                  <v-toolbar-title v-if="view == 'calendar'">{{ title }}</v-toolbar-title>
                  <v-toolbar-title v-else>All Calendar Items</v-toolbar-title>
                  <div class="flex-grow-1"></div>
                  <v-menu bottom right>
                      <template v-slot:activator="{ on }">
                      <v-btn outlined v-on="on">
                          <span>{{ viewToLabel[view] }}</span>
                          <v-icon right>mdi-menu-down</v-icon>
                      </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="view = 'calendar'">
                            <v-list-item-title>Calendar</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="view = 'list'">
                            <v-list-item-title>List</v-list-item-title>
                        </v-list-item>
                      </v-list>
                  </v-menu>
                </v-toolbar>
            </v-sheet>

            <v-sheet v-if="view == 'calendar'">
                <v-calendar
                ref="calendar"
                v-model="focus"
                color="primary"
                :events="events"
                :event-color="getEventColor"
                :event-margin-bottom="3"
                :now="today"
                :type="type"
                @click:event="showEvent"
                @click:more="viewDay"
                @change="updateRange"
                @mousedown:event="startDrag"
                @mousedown:time="startTime"
                @mousemove:time="mouseMove"
                @mouseup:time="endDrag"
                @mouseleave.native="cancelDrag"
                >
                  <template v-slot:event="{ event, timed }">
                    <div
                      class="v-event-draggable"
                      v-html="event.name"
                    ></div>
                    <div
                      v-if="timed"
                      class="v-event-drag-bottom"
                      @mousedown.stop="extendBottom(event)"
                    ></div>
                  </template>                
                </v-calendar>
            </v-sheet>

            <v-sheet v-else>
              <v-list
                two-line
                tile
              >
              <template v-for="(event, index) in events">
                <v-divider
                  :key="`div-${index}`"
                ></v-divider>
                <v-list-item
                  :key="`listitem-${index}`"
                >
                  <v-list-item-content>
                    <v-list-item-title v-text="event.name" class="font-weight-bold"></v-list-item-title>

                    <v-list-item-subtitle v-text="event.date"></v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
              </v-list>
            </v-sheet>
        </v-col>
    </v-row>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card color="red">
        <v-card-title class="subtitle-2 justify-center white--text">Are you sure you want to delete this item?</v-card-title>
        <v-card-actions class="red darken-4">
          <v-spacer></v-spacer>
          <v-btn tile color="white darken-1" text @click="closeDelete">Cancel</v-btn>
          <v-btn tile color="red--text" @click="deleteItemConfirm" :loading="loading">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

import axios from 'axios'
import mixin from '../mixin/main.js'
import { required } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'

setInteractionMode('eager')

extend('required', {
    ...required,
    message: '{_field_} can not be empty',
})

export default {
  mixins: [mixin],
  data: () => ({
    view: 'calendar',
    viewToLabel: {
      'calendar': 'Calendar',
      'list': 'List',
    },
    loading: false,
    today: new Date().toISOString().substr(0, 10),
    focus: new Date().toISOString().substr(0, 10),
    type: 'month',
    typeToLabel: {
      month: 'Month',
      week: 'Week',
      day: 'Day',
      '4day': '4 Days',
    },
    name: null,
    details: null,
    start: null,
    end: null,
    color: '#1976D2', // default event color
    currentlyEditing: null,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    properties: [],
    contacts: [],
    dialog: false,
    dialogDate: false,
    dialogDelete: false,
    apiUrl: '',
    form: {
      id: '',
      property_id: '',
      task: '',
      status: 'scheduled',
      date: '',
      assignee: '',
      description: '',
      contact: []
    },
    defaultItem: {
      id: '',
      property_id: '',
      task: '',
      status: 'scheduled',
      date: '',
      assignee: '',
      description: '',
      contact: []
    },
    editedIndex: -1,
    dragEvent: null,
    dragStart: null,
    createEvent: null,
    createStart: null,
    extendOriginal: null,
    statuses: [
        { label: 'Reported', value: 'reported' },
        { label: 'Scheduled', value: 'scheduled' },
        { label: 'Completed', value: 'completed' },
    ],
    calTypes: [
        { label: 'Calendar', value: 'calendar' },
        { label: 'List', value: 'list' },
    ],
  }),
  created() {
    this.apiUrl = this.$route.meta.api
  },
  mounted () {
    this.getEvents()
  },
  computed: {
    title () {
      const { start, end } = this
      if (!start || !end) {
        return ''
      }
      const startMonth = this.monthFormatter(start)
      const endMonth = this.monthFormatter(end)
      const suffixMonth = startMonth === endMonth ? '' : endMonth
      const startYear = start.year
      const endYear = end.year
      const suffixYear = startYear === endYear ? '' : endYear
      const startDay = start.day + this.nth(start.day)
      const endDay = end.day + this.nth(end.day)
      switch (this.type) {
        case 'month':
        return `${startMonth} ${startYear}`
        case 'week':
        case '4day':
        return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`
        case 'day':
        return `${startMonth} ${startDay} ${startYear}`
      }
      return ''
    },
    monthFormatter () {
      return this.$refs.calendar.getFormatter({
        timeZone: 'UTC', month: 'long',
      })
    },
    cheight() {
      return window.innerHeight - 128
    },
    computedDateFormatted () {
        return this.formatDate(this.form.date)
    },
    formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
  },
  components: {
      ValidationProvider,
      ValidationObserver,
  },
  watch: {
      dialog (val) {
          val || this.close()
      },
      dialogDelete (val) {
          val || this.closeDelete()
      },
  },
  methods: {
    getContacts() {
        this.loading = true
        axios.get('tasks/contacts?property_id=' + this.form.property_id)
            .then(response => {
                this.loading = false
                this.contacts = response.data
                this.$nextTick()
            })
    },
    async getEvents () {
      this.loading = true
      axios.get(this.apiUrl)
      .then(response => {
          this.loading = false
          this.events = response.data.items
          this.properties = response.data.properties
          this.$nextTick()
      })
    },
    async save () {
        if (this.editedIndex > -1) {
          let valid1 = await this.$refs.observer1.validate()

          if(valid1) {
              this.loading = true
              axios.post('tasks/update', this.form).then(() => {
                  this.loading = false
                  this.$store.commit('SET_SNACKTYPE', 'green')
                  this.$store.commit('SET_SNACK', 'Successfully saved!')
                  this.getEvents()
                  this.close()
              }).catch(error => {
                  console.log(error)
                  this.loading = false
                  this.$store.commit('SET_SNACKTYPE', 'red')
                  if(error.response.data.error) {
                      this.$store.commit('SET_SNACK', error.response.data.error)
                  } else {
                      this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                  }
              })
          } else {
              this.$store.commit('SET_SNACKTYPE', 'red')
              this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
          }
        } else {
          let valid1 = await this.$refs.observer1.validate()

          if(valid1) {
              this.loading = true
              axios.post('tasks/add', this.form).then(() => {
                  this.loading = false
                  this.$store.commit('SET_SNACKTYPE', 'green')
                  this.$store.commit('SET_SNACK', 'Successfully saved!')
                  this.getEvents()
                  this.close()
              }).catch(error => {
                  this.loading = false
                  this.$store.commit('SET_SNACKTYPE', 'red')
                  if(error.response.data.error) {
                      this.$store.commit('SET_SNACK', error.response.data.error)
                  } else {
                      this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                  }
              })
          } else {
              this.$store.commit('SET_SNACKTYPE', 'red')
              this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
          }
        }
    },
    setDialogDate( { date }) {
      this.dialogDate = true
      this.focus = date
    },
    viewDay ({ date }) {
      this.focus = date
      this.type = 'day'
    },
    getEventColor (event) {
      return event.color
    },
    showEvent ({ nativeEvent, event }) {

      if(event.type == 'insuarance' || event.type == 'lease') {
        this.$router.push({ path: '/property/edit/' + event.property_id })
      } else {

        this.editedIndex = 1
        this.form.id = event.id
        this.form.task = event.title
        this.form.description = event.description
        this.form.assignee = event.assignee
        this.form.property_id = event.property_id
        this.form.date = event.start
        this.form.contact = event.contact
        this.dialog = true

        this.getContacts()

        nativeEvent.stopPropagation()
      }
    },
    setToday () {
      this.focus = this.today
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    updateRange ({ start, end }) {
      this.start = start
      this.end = end
    },
    nth (d) {
      return d > 3 && d < 21
      ? 'th'
      : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10]
    },
    deleteItem (id) {
        this.editedIndex = id
        this.dialogDelete = true
    },

    deleteItemConfirm () {
        this.loading = true
        axios.delete('crm/custom_calendar/delete?id=' + this.editedIndex)
            .then(() => {
              this.close()
              this.closeDelete()
              this.getEvents()
              this.$emit('update-job')
              this.$nextTick()
        })
    },

    closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
    },
    
    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.form = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    startDrag ({ event }) {
      if (event) {
        this.dragEvent = event
        this.dragTime = null
        this.extendOriginal = null
      }
    },
    startTime (tms) {
      const mouse = this.toTime(tms)

      if (this.dragEvent && this.dragTime === null) {
        const start = this.dragEvent.start

        this.dragTime = mouse - start
      } else {
        this.createStart = this.roundTime(mouse)
        this.createEvent = {
          name: `Event #${this.events.length}`,
          color: this.rndElement(this.colors),
          start: this.createStart,
          end: this.createStart,
          timed: true,
        }

        this.events.push(this.createEvent)
      }
    },
    extendBottom (event) {
      this.createEvent = event
      this.createStart = event.start
      this.extendOriginal = event.end
    },
    mouseMove (tms) {
      const mouse = this.toTime(tms)

      if (this.dragEvent && this.dragTime !== null) {
        const start = this.dragEvent.start
        const end = this.dragEvent.end
        const duration = end - start
        const newStartTime = mouse - this.dragTime
        const newStart = this.roundTime(newStartTime)
        const newEnd = newStart + duration

        this.dragEvent.start = newStart
        this.dragEvent.end = newEnd
      } else if (this.createEvent && this.createStart !== null) {
        const mouseRounded = this.roundTime(mouse, false)
        const min = Math.min(mouseRounded, this.createStart)
        const max = Math.max(mouseRounded, this.createStart)

        this.createEvent.start = min
        this.createEvent.end = max
      }
    },
    endDrag () {
      this.dragTime = null
      this.dragEvent = null
      this.createEvent = null
      this.createStart = null
      this.extendOriginal = null
    },
    cancelDrag () {
      if (this.createEvent) {
        if (this.extendOriginal) {
          this.createEvent.end = this.extendOriginal
        } else {
          const i = this.events.indexOf(this.createEvent)
          if (i !== -1) {
            this.events.splice(i, 1)
          }
        }
      }

      this.createEvent = null
      this.createStart = null
      this.dragTime = null
      this.dragEvent = null
    },
    roundTime (time, down = true) {
      const roundTo = 15 // minutes
      const roundDownTime = roundTo * 60 * 1000

      return down
        ? time - time % roundDownTime
        : time + (roundDownTime - (time % roundDownTime))
    },
    toTime (tms) {
      return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime()
    },
  }
}
</script>

<style lang="sass">
.v-calendar .v-event
    white-space: normal!important
    height: auto!important

    div 
      white-space: normal
      text-align: center
      padding: 6px!important

.v-list
    border-radius: 0

.v-sheet
    border-radius: 0
</style>